import { Target, Text } from "@modernatx-internal/component-library";
import { usePathname } from "next/navigation";
import React from "react";

import { ContentComponentProps, PageHeaderSubnavLinkContent } from "@/content-V2/types";
import { useParseLocalizedPathname } from "@/hooks/useParseLocalizedPathname";

import { PageHeaderScrollableContext } from "./PageHeader";

export const PageHeaderSubnavLink: React.FC<ContentComponentProps<PageHeaderSubnavLinkContent>> = ({
  children,
  href
}) => {
  const target = React.useRef<HTMLAnchorElement>(null);
  const { scrollTo } = React.useContext(PageHeaderScrollableContext);
  const { getLocalizedPathnamesMatch } = useParseLocalizedPathname();
  const pathname = usePathname();
  const active = href ? getLocalizedPathnamesMatch(pathname, href) : false;

  React.useEffect(() => {
    if (active && target.current) {
      scrollTo(target.current);
    }
  }, [active, scrollTo]);

  return (
    <>
      <Target
        ref={target}
        href={href}
        sx={{
          backgroundColor: "surface-neutral",
          borderColor: "stroke-neutral-secondary",
          borderStyle: "solid",
          borderWidth: "0 0 1px 0",
          color: active ? "tab-stroke-selected" : "tab-text-default",
          display: "block",
          flexShrink: 0,
          transition: "transition-color-medium",
          ":active": {
            color: "tab-stroke-click"
          },
          ":hover": {
            color: "tab-stroke-selected"
          },
          "&:last-of-type": {
            borderWidth: 0
          }
        }}
      >
        <Text
          variant="title-1-medium"
          sx={{
            color: "inherit",
            display: "block",
            px: [0, null, 4],
            py: 2,
            whiteSpace: "nowrap",
            textAlign: "center"
          }}
        >
          {children}
        </Text>
      </Target>
    </>
  );
};
